// RV prefix = ReactViewer
// Add to all constants
var ReactViewer3DInternalConstants = {
    DISPATCHER_NAME: 'REACT_VIEWER_3D',
};

export default ReactViewer3DInternalConstants;